import { useCallback, useEffect, useState } from "react";
import { useRecoilValue } from "recoil";
import { userState } from "../../../../recoil/auth";
import { getHistoryItems, MemberHistoryDto } from "../../../../api/member";

const useWalletHistory = () => {
  const limit = 10;
  const user = useRecoilValue(userState);
  const [currentPage, setCurrentPage] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [historyList, setHistoryList] = useState<MemberHistoryDto[]>([]);
  const [historyloading, setHistoryLoading] = useState(false);

  const getHistoryList = useCallback(() => {
    if (!user?.id || currentPage === 0) {
      return;
    }
    setHistoryLoading(true);
    getHistoryItems(currentPage, limit)
      .then((res) => {
        setTotalPages(Math.max(1, Math.ceil(res.total / limit)));
        setHistoryList(res.list);
      })
      .catch((e: any) => {
        console.error(e);
      })
      .finally(() => {
        setTimeout(() => {
          setHistoryLoading(false);
        }, 80);
      });
  }, [user, currentPage]);

  useEffect(() => {
    getHistoryList();
  }, [getHistoryList]);

  return {
    totalPages,
    historyList,
    currentPage,
    setCurrentPage,
    historyloading,
  };
};

export default useWalletHistory;
